import Socket from '../utils/socket-helper';
var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = initialState.envCfg;
var socket;
export var initWebSocket = function initWebSocket(id, userName, alarmLevels) {
  var socketURL = 'ws://' + window.location.host + cfg.contextRoot + '/WebSocketApi';

  if (location.protocol === 'https:') {
    socketURL = 'wss://' + window.location.host + cfg.contextRoot + '/WebSocketApi';
  }

  socket = new Socket(socketURL, id, userName, alarmLevels, '', '', '');
  return socket;
};
export var getWebSocket = function getWebSocket() {
  return socket;
};